<script setup>
import { binder } from '..'
const model = defineModel()
</script>
<template>
  <input type="checkbox" v-model="model" v-bind="binder" class="form-check-input" />
</template>
